import { Expose } from "class-transformer";
import { IsString, IsBoolean, IsNumber, IsOptional } from "class-validator";

export class DocumentTemplate {
  @IsNumber()
  @Expose()
  documentTypeId!: number;
  @IsString()
  @Expose()
  documentTypeName!: string;
  @IsString()
  @Expose()
  counterTemplate!: string;
  @IsBoolean()
  @Expose()
  isYearly!: boolean;
  @IsBoolean()
  @Expose()
  isMonthly!: boolean;
  @IsOptional()
  @IsString()
  @Expose()
  isInheritedFromOffice!: string | null;

  constructor(template?: DocumentTemplate) {
    this.documentTypeId = template != undefined ? template.documentTypeId : 0;
    this.documentTypeName = template != undefined ? template.documentTypeName : "";
    this.counterTemplate = template != undefined ? template.counterTemplate : "";
    this.isYearly = template != undefined ? template.isYearly : false;
    this.isMonthly = template != undefined ? template.isMonthly : false;
    this.isInheritedFromOffice = template != undefined ? template.isInheritedFromOffice : "";
  }
}

export class DocumentTemplateAddEdit {
  documentTypeId!: number;
  documentTypeName!: string;
  counterTemplate!: string;
  isYearly!: boolean;
  isMonthly!: boolean;
  isInheritedFromOffice!: string | null;

  constructor(template?: DocumentTemplate) {
    this.documentTypeId = template != undefined ? template.documentTypeId : 0;
    this.documentTypeName = template != undefined ? template.documentTypeName : "";
    this.counterTemplate = template != undefined ? template.counterTemplate : "";
    this.isYearly = template != undefined ? template.isYearly : false;
    this.isMonthly = template != undefined ? template.isMonthly : false;
    this.isInheritedFromOffice = template != undefined ? template.isInheritedFromOffice : "";
  }
}
